<template>
  <div class="info-box" :style="{ backgroundColor: `#${organizationDetails.lightBrandColor}` }">
    <img class="icon" :src="require('../assets/icons/lightbulb.png')" />
    <div v-if="content">
      <p v-html="content">{{ content }}</p>
    </div>
    <div>
      <ul>
        <li v-for="(bullet, i) in bullets" :key="i">{{ bullet }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'InfoBox',
  props: {
    content: {
      type: String,
      default: '',
    },
    bullets: {
      type: Array,
    },
  },
  computed: mapState(['organizationDetails']),
}
</script>

<style lang="scss" scoped>
@import '../styles/mixins/spinners';
@import '../styles/variables';
@import '@/styles/mixins/buttons';

.info-box {
  display: flex;
  width: 100vw;
  max-width: $maximum-width;
  padding: 1rem 2rem;
}
.icon {
  width: 3rem;
  height: 3rem;
  margin-right: 1rem;
}
ul {
  margin-left: 0.8rem;
  li {
    font-size: 0.9rem;
  }
}
</style>
